import {PaymentSupportProps} from '../components/PaymentSupportItem';


export const PAYMENT_ATM: PaymentSupportProps[] = [
  {
    src: require('../assets/image/payment-vietcombank.png'),
    isFull: false,
    children: null
  },
  {
    src: require('../assets/image/payment-vietinbank.png'),
    isFull: false,
    children: null
  },
  {
    src: require('../assets/image/payment-techcombank.png'),
    isFull: false,
    children: null
  },
  {
    src: require('../assets/image/payment-tpbank.png'),
    isFull: false,
    children: null
  },
  {
    src: require('../assets/image/payment-vib.png'),
    isFull: false,
    children: null
  },
  {
    src: require('../assets/image/payment-hdbank.png'),
    isFull: false,
    children: null
  },
  {
    src: require('../assets/image/payment-mbbank.png'),
    isFull: false,
    children: null
  },
  {
    isFull: false,
    children: '+21'
  },
];

export const PAYMENT_VISA_MASTERCARD = [
  {
    src: require('../assets/image/payment-visa.jpg'),
    isFull: true,
    children: null
  },
  {
    src: require('../assets/image/payment-mastercard.png'),
    isFull: false,
    children: null
  }
];

export const PAYMENT_COD: PaymentSupportProps[] = [
  {
    src: require('../assets/image/payment-ghn.png'),
    isFull: false,
    additionalText: 'nationalWideDelivery'
  }
];

export const PAYMENT_INSTRUCTIONS = [
  'paymentInstruct1',
  'paymentInstruct2',
  'paymentInstruct3',
  'paymentInstruct4'
];

export const COD_INSTRUCTION = [
  'codInstruct1',
  'codInstruct2',
  'codInstruct3',
];